module.exports = __webpack_public_path__ + "img/kv_land.5682374e.png";